import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApAnimationComponent } from '@ap/animation';
import { ApButtonComponent } from '@ap/button';
import { ApContentComponent, ApContentPipe } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';

import { MijnContextErrorComponent } from './mijn-context-error/mijn-context-error.component';
import { MijnErrorComponent } from './mijn-error.component';

/**
 * @name MijnErrorModule
 * @ngdoc module
 */
@NgModule({
    declarations: [MijnContextErrorComponent, MijnErrorComponent],
    imports: [ApIllustrationComponent, ApButtonComponent, ApContentComponent, ApContentPipe, CommonModule, ApAnimationComponent],
    exports: [MijnContextErrorComponent]
})
export class MijnErrorModule {}
